import { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

const AnimatedArrow = ({ children, className }: {
  children: ReactNode;
  className?: string
}) => {
  return (
    <div className={twMerge('w-full overflow-hidden', className)}>
      <div className="flex relative can-hover:group-hover:left-0.5 -left-12 transition-[left] duration-300">
        <div className="w-4 shrink-0 h-4 mr-8 flex justify-center">{children}</div>
        <div className="w-4 shrink-0 h-4 flex justify-center">{children}</div>
      </div>
    </div>
  );
};

export default AnimatedArrow;
